export default __webpack_public_path__ + "static/media/long-backarow.171908d3.svg";